import React, { Component } from 'react';
import '../../assets/css/travelstory.css';
import Banner from "../../widget/PageBanner";
import TravelStories from './StoryThumbs.js';
import {Redirect} from 'react-router';

class TravelStoriesMain extends Component {

	state = { 
		redirect: false,
		routeLink: ''
	};

	componentDidMount = () =>{
		window.scrollTo(0, 0);
	}

	goToContactUs = () => {
		this.setState({
			redirect: true,
			routeLink: '/contactus'
		});
	}

  render() {
	const {redirect, routeLink} = this.state;
		
    return (
		<div>	
			{ redirect &&
				<Redirect push to={routeLink}/>
			}
			<div className="travel-stories-wrapper">
				<Banner pagename="TravelStories"/>
			</div>
			
			<div className="section-content-wrapper margin-top-5">
				<TravelStories/>
			</div>


			
			
		</div>
    );
  }
}

export default TravelStoriesMain;